import React from 'react';

import {
    Chart, Series, CommonSeriesSettings, Label, Format, Legend, Export,Tooltip,Palette
} from 'devextreme-react/chart';


const grossProductData = [{
    state: 'السبت',
    year2016: 803,
    year2017: 823,
    year2018: 863,
}, {
    state: 'الاحد',
    year2016: 316,
    year2017: 332,
    year2018: 332,
}, {
    state: 'الاثنين',
    year2016: 452,
    year2017: 459,
    year2018: 470,
}, {
    state: 'الثلاثاء',
    year2016: 621,
    year2017: 642,
    year2018: 675,
}, {
    state: 'الاربعاء',
    year2016: 290,
    year2017: 294,
    year2018: 301,
}, {
    state: 'الخميس',
    year2016: 290,
    year2017: 294,
    year2018: 301,
}, {
    state: 'الجمعة',
    year2016: 290,
    year2017: 294,
    year2018: 301,
}
];

const BarChart = () => {
    const onPointClick = (e) => {
        e.target.select();
    }
   
    return (
      
                <Chart id="chart"
                    dataSource={grossProductData}
                    onPointClick={onPointClick}
                    Palette={'Soft Pastel'}
                    paletteExtensionMode={'alternate'}
                >
                   
                    <CommonSeriesSettings
                        argumentField="state"
                        type="bar"
                        hoverMode="allArgumentPoints"
                        selectionMode="allArgumentPoints"
                    >
                        <Label visible={false}>
                            <Format type="fixedPoint" precision={0} />
                        </Label>
                    </CommonSeriesSettings>
                    <Series
                        argumentField="state"
                        valueField="year2018"
                        name="المسجلين"
                    />
                    <Series
                        valueField="year2017"
                        name="الغير مسجلين"
                    />
                    <Series
                        valueField="year2016"
                        name="المفعلين"
                    />
                    <Legend verticalAlignment="top" horizontalAlignment="center"></Legend>
                    <Export enabled={true} />
                    <Tooltip
          enabled={true}
          location="edge"
        />
                </Chart>
      
    );



}

export default BarChart;
